import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { keyframes } from '@mui/system';
import { getStatusHue, normalizeStatus, statusLabels } from '../theme/statusTokens';

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(11, 118, 209, 0.35); }
  70% { box-shadow: 0 0 0 5px rgba(11, 118, 209, 0); }
  100% { box-shadow: 0 0 0 0 rgba(11, 118, 209, 0); }
`;

export interface StatusDotProps {
  status?: string;
  size?: number;
  withTooltip?: boolean;
}

/** Small colored dot — the quietest status signal, used in lists and nav. */
const StatusDot: React.FC<StatusDotProps> = ({ status, size = 8, withTooltip = true }) => {
  const canonical = normalizeStatus(status);
  const hue = getStatusHue(status);
  const dot = (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: hue,
        flexShrink: 0,
        ...(canonical === 'inprogress' && { animation: `${pulse} 1.6s ease-out infinite` }),
      }}
    />
  );
  if (!withTooltip) return dot;
  return (
    <Tooltip title={statusLabels[canonical]} arrow>
      {dot}
    </Tooltip>
  );
};

export default StatusDot;
